"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uiSchema = void 0;
var _constants = require("../../common/constants");
const uiSchema = exports.uiSchema = {
  "ui:submitButtonOptions": {
    props: {
      disabled: false,
      type: "primary",
      block: true,
      size: "large"
    },
    submitText: _constants.formConstants.buttons.VERIFY_OTP
  },
  otp: {
    "ui:options": {
      label: false,
      placeholder: _constants.formConstants.requiredFields.OTP
    }
  }
};